import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

@Component({
  selector: 'app-incentive-setup',
  templateUrl: './incentive-setup.component.html',
  styleUrls: ['./incentive-setup.component.css']
})
export class IncentiveSetupComponent implements OnInit {
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  dataresult: any = [];
  recordsperpage: number = 25;
  showLoader: boolean;
  groupIncentive2: any;
  groupIncentive3: any;
  groupIncentive4: any;
  groupIncentive5: any;
  constructor(private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
  }

  ngOnInit() {
    this.model = {
      groupIncentiveType1: 'Amount',
      groupIncentiveType2: 'Amount',
      groupIncentiveType3: 'Amount',
      groupIncentiveType4: 'Amount',
      groupIncentiveType5: 'Amount',
      groupIncentiveAmt1: '',
      groupIncentiveAmt2: '',
      groupIncentiveAmt3: '',
      groupIncentiveAmt4: '',
      groupIncentiveAmt5: '',
      quantity1: '1',
      quantity2: '1',
      quantity3: '1',
      quantity4: '1',
      quantity5: '1',
      groupIncentivePercent1: '',
      groupIncentivePercent2: '',
      groupIncentivePercent3: '',
      groupIncentivePercent4: '',
      groupIncentivePercent5: '',
      salaryTimes1: '',
      salaryTimes2: '',
      salaryTimes3: '',
      salaryTimes4: '',
      salaryTimes5: '',
      approval1: 10,
      approval2: 10,
      approval3: 10,
      approval4: 10,
      approval5: 10,
    }
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.getCollectiveInventorySetup();
  }

  getCollectiveInventorySetup() {
    this.loginservice.getCollectiveInventorySetup()
      .subscribe(
        data => {
          if (data) {
            this.model = data;
            if (this.model.groupIncentiveAmt2 > 0 && this.model.quantity2 > 0 && this.model.groupIncentivePercent2 > 0) {
              this.groupIncentive2 = 1;
            } else {
              this.groupIncentive2 = '';
            }
            if (this.model.groupIncentiveAmt3 > 0 && this.model.quantity3 > 0 && this.model.groupIncentivePercent3 > 0) {
              this.groupIncentive3 = 1;
            } else {
              this.groupIncentive3 = '';
            }
            if (this.model.groupIncentiveAmt4 > 0 && this.model.quantity4 > 0 && this.model.groupIncentivePercent4 > 0) {
              this.groupIncentive4 = 1;
            } else {
              this.groupIncentive4 = '';
            }
            if (this.model.groupIncentiveAmt5 > 0 && this.model.quantity5 > 0 && this.model.groupIncentivePercent5 > 0) {
              this.groupIncentive5 = 1;
            } else {
              this.groupIncentive5 = '';
            }
          }
        }, error => { alert('Network Error getCollectiveInventorySetup API'); });
  }

  save() {

    if ((this.model.groupIncentiveAmt1 && this.model.groupIncentiveAmt1 <= 0) && (this.model.quantity1 && this.model.quantity1 <= 0) && (this.model.groupIncentivePercent1 && this.model.groupIncentivePercent1 <= 0)) {
      alert('Please Fill Empty Inupts Or Remove It And Save')
      this._flashMessagesService.show('Please Fill Empty Inupts Or Remove It And Save', { cssClass: 'alert-danger' });
      return false;
    }
    if ((this.model.groupIncentiveAmt2 && this.model.groupIncentiveAmt2 <= 0) && (this.model.quantity2 && this.model.quantity2 <= 0) && (this.model.groupIncentivePercent2 && this.model.groupIncentivePercent2 <= 0)) {
      alert('Please Fill Empty Inupts Or Remove It And Save')
      this._flashMessagesService.show('Please Fill Empty Inupts Or Remove It And Save', { cssClass: 'alert-danger' });
      return false;
    }
    if ((this.model.groupIncentiveAmt3 && this.model.groupIncentiveAmt3 <= 0) && (this.model.quantity3 && this.model.quantity3 <= 0) && (this.model.groupIncentivePercent3 && this.model.groupIncentivePercent3 <= 0)) {
      alert('Please Fill Empty Inupts Or Remove It And Save')
      this._flashMessagesService.show('Please Fill Empty Inupts Or Remove It And Save', { cssClass: 'alert-danger' });
      return false;
    }
    if ((this.model.groupIncentiveAmt4 && this.model.groupIncentiveAmt4 <= 0) && (this.model.quantity4 && this.model.quantity4 <= 0) && (this.model.groupIncentivePercent4 && this.model.groupIncentivePercent4 <= 0)) {
      alert('Please Fill Empty Inupts Or Remove It And Save')
      this._flashMessagesService.show('Please Fill Empty Inupts Or Remove It And Save', { cssClass: 'alert-danger' });
      return false;
    }
    if ((this.model.groupIncentiveAmt5 && this.model.groupIncentiveAmt5 <= 0) && (this.model.quantity5 && this.model.quantity5 <= 0) && (this.model.groupIncentivePercent5 && this.model.groupIncentivePercent5 <= 0)) {
      alert('Please Fill Empty Inupts Or Remove It And Save')
      this._flashMessagesService.show('Please Fill Empty Inupts Or Remove It And Save', { cssClass: 'alert-danger' });
      return false;
    }

    this.loginservice.saveCollectiveInventorySetup(this.model, this.currentUser).subscribe(
      data => {
        this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
        this.ngOnInit();
      }, error => { alert('Network Error saveCollectiveInventorySetup API'); });
  }

  changecharge(selectvalue, amtvalue, fieldname) {
    if (selectvalue == '') {
      this.model[fieldname] = 0;
    }
  }

  addIncentive(type, index, name) {
    if (type == 1) {

      if (index == '2') {
        if (this.model.groupIncentiveAmt2 > 0 && this.model.quantity2 > 0 && this.model.groupIncentivePercent2 > 0) {
        } else {
          this.groupIncentive2 = 1;
          this.model.groupIncentiveAmt2 = "";
          this.model.quantity2 = 1;
          this.model.groupIncentivePercent2 = '';
          this.model.groupIncentiveType2 = 'Amount';
        }

      }

      if (index == '3') {
        if (this.model.groupIncentiveAmt3 > 0 && this.model.quantity3 > 0 && this.model.groupIncentivePercent3 > 0) {
        } else {
          this.groupIncentive3 = 1;
          this.model.groupIncentiveAmt3 = "";
          this.model.quantity3 = 1;
          this.model.groupIncentivePercent3 = '';
          this.model.groupIncentiveType3 = 'Amount';
        }
      }

      if (index == '4') {
        if (this.model.groupIncentiveAmt4 > 0 && this.model.quantity4 > 0 && this.model.groupIncentivePercent4 > 0) {
        } else {
          this.groupIncentive4 = 1;
          this.model.groupIncentiveAmt4 = "";
          this.model.quantity4 = 1;
          this.model.groupIncentivePercent4 = '';
          this.model.groupIncentiveType4 = 'Amount';
        }
      }

      if (index == '5') {
        if (this.model.groupIncentiveAmt5 > 0 && this.model.quantity5 > 0 && this.model.groupIncentivePercent5 > 0) {
        } else {
          this.groupIncentive5 = 1;
          this.model.groupIncentiveAmt5 = "";
          this.model.quantity5 = 1;
          this.model.groupIncentivePercent5 = '';
          this.model.groupIncentiveType5 = 'Amount';
        }
      }

    } else {

      if (index == '2') {
        this.groupIncentive2 = '';
        this.model.groupIncentiveAmt2 = "";
        this.model.quantity2 = 1;
        this.model.groupIncentivePercent2 = '';
        this.model.groupIncentiveType2 = 'Amount';
      }

      if (index == '3') {
        this.groupIncentive3 = '';
        this.model.groupIncentiveAmt3 = "";
        this.model.quantity3 = 1;
        this.model.groupIncentivePercent3 = '';
        this.model.groupIncentiveType3 = 'Amount';
      }

      if (index == '4') {
        this.groupIncentive4 = '';
        this.model.groupIncentiveAmt4 = "";
        this.model.quantity4 = 1;
        this.model.groupIncentivePercent4 = '';
        this.model.groupIncentiveType4 = 'Amount';
      }

      if (index == '5') {
        this.groupIncentive5 = '';
        this.model.groupIncentiveAmt5 = "";
        this.model.quantity5 = 1;
        this.model.groupIncentivePercent5 = '';
        this.model.groupIncentiveType5 = 'Amount';
      }
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/incentive-setup/incentive-setup.component.ts